import { ArrowIcon, SimpleButton } from '@/components/common';
import NavigationService, {
  InternalPage,
} from '@/services/navigation/NavigationService';

const styles = {
  button: 'px-5 py-3.5 ring-[2px] ring-tertiary rounded-full',
  container: 'flex flex-row items-center justify-center',
  icon: 'text-tertiary',
};

export function NavigateToStoredInstrumentsPageBtn() {
  return (
    <SimpleButton
      className={styles.button}
      onClick={() =>
        NavigationService.navigateTo({ page: InternalPage.StoredInstruments })
      }
    >
      <span className={styles.container}>
        <ArrowIcon
          direction="left"
          className={styles.icon}
        />
      </span>
    </SimpleButton>
  );
}
